import { render, staticRenderFns } from "./Repositories.vue?vue&type=template&id=f573d10e"
import script from "../services/Repositories.js?vue&type=script&lang=js&external"
export * from "../services/Repositories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports